export const ListTypeId = {
  HIGHLIGHTED: 1,
  OUR_CHOICE: 2,
  BANNERS: 3,
  TRENDING: 4,
  NEW_APPS: 5,
}
